import React from 'react'
import { getIndexPageURL } from 'src/dataLayer/env'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import { NavBarWrapper } from 'src/viewLayer/components/DesignSystem'

export default () => {
  const { locale } = useRouteParamsContext()

  return <NavBarWrapper logoUrl={getIndexPageURL(locale)} />
}
